
  <div class="header">
    <div class="back-btn d-flex justify-content-center align-items-center" (click)="backToPreviousPage()">
      <svg width="8px" height="20px" viewBox="0 0 19 41" version="1.1" xmlns="http://www.w3.org/2000/svg">
        <g id="Symbols" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
          <g transform="translate(-12.000000, -4.000000)" fill="#000000">
            <path d="M28.949609,44.5859918 L12,24.4995264 L28.949609,4.41407071 C29.3745432,3.90817291 30.1162287,3.86071343 30.6006146,4.29996602 C31.0869498,4.74022838 31.1356807,5.50563864 30.7107466,6.00951689 L15.1061126,24.4995264 L30.7107466,42.9905456 C31.1356807,43.4944239 31.0869498,44.2598341 30.6006146,44.6990867 C30.3784013,44.9000322 30.1045332,45 29.8306651,45 C29.5051422,45 29.1815685,44.8596411 28.949609,44.5859918 Z" id="Fill-1"></path>
          </g>
        </g>
      </svg>
    </div>
    <div class="d-flex flex-column justify-content-start">
      <span class="breadcumb-header text-semi-bold-font">{{influencerGroup.influencer_group_name}}</span>
      <span class="breadcumb-subheader">{{influencerGroup.influencer_group_description}}</span>
      <span class="total-influecner">{{totalInfluencer}}</span>
    </div>
  </div>
  <div class="separator-line"></div>
  <div class="col-md-4 col-sm-4 light-text search-all" *ngIf="influencerList.length > 0">
    <achoo-checkbox name="selectAllInfluencers"
                    [(model)]="checkAll"
                    label="{{'group_details.search_bar.select_all' | translate}}"
                    (selectEvent)="onCheckSelectAll($event)">
    </achoo-checkbox>
  </div>




// WEBPACK FOOTER //
// ./src/app/main/group-details/monthly-visited-breadcrumb/monthly-visited-breadcrumb.component.html